/**************************************************
 * Nombre:       Imagen_Interactiva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import jose from '../../../../Recursos/img_jose.png'

const Imagen_Interactiva = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


              <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <svg width="'100%" height="auto" viewBox="0 0 463 483" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                        <pattern id="img1" patternUnits="userSpaceOnUse" width="463" height="483">
                            <image href={jose} x="0" y="0" width="463" height="483"/>
                        </pattern>
                    </defs>
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M0 72C0 32.2355 32.2355 0 72 0H72.9402H277.095H357.977C377.295 0 392.955 15.6604 392.955 34.9784V34.9784C392.955 54.2964 408.615 69.9568 427.933 69.9568V69.9568C447.251 69.9568 462.912 85.6172 462.912 104.935L462.912 410.301C462.912 450.066 430.676 482.301 390.912 482.301H144.94C105.176 482.301 72.9402 450.066 72.9402 410.301V331.402C72.9402 311.261 56.612 294.932 36.4701 294.932V294.932C16.3282 294.932 0 278.604 0 258.462V72Z"
                          fill="url(#img1)"/>
                    <circle cx="36.7046" cy="334.301" r="28" fill="#9CAD6C" />
                    <circle cx="36.7046" cy="394.301" r="28" fill="#2F322B"/>
                    <circle cx="36.7046" cy="454.301" r="28" fill="#9CAD6C"/>
                    <circle cx="430.912" cy="32" r="32" fill="#9CAD6C"/>

                </svg>
            </Grid>



        </Grid>
    )

}
export default Imagen_Interactiva